
export const categories = [
    {
        label: 'Appliances',
        value: '4EUMO1WT42KxrMGpu7TA',
    },
    {
        label: 'Home & Decor',
        value: '6jV9NZbBGuSXmxSkm90G',
    },
    {
        label: 'Tickets',
        value: 'GA3ZnpjEGYJ2sSeHNqhu',
    },
    {
        label: 'Books',
        value: 'H3qLbPzU5wq49XwdrlW9',
    },
    {
        label: "Women's Jewelry",
        value: 'Kp3JO9iWEBtTnfpkMkg3',
    },
    {
        label: "Men's Wear",
        value: 'MOiYL4XmfFrDeRJaucQT',
    },
    {
        label: 'Jewelry & Watches',
        value: 'MiXX5WcgQbPojjYOXOdh',
    },
    {
        label: 'Sporting Goods',
        value: 'NyYSC3GkxiNVwnf07N5g',
    },
    {
        label: 'Furniture',
        value: 'OBXXqTPp4mOlSsITTrIG',
    },
    {
        label: 'Movies & Tv',
        value: 'R8J1ClnLIfhlxFyz5yQW',
    },
    {
        label: 'Shoes',
        value: 'Z4M5Dtm0WnCKZiZp3GyX',
    },
    {
        label: 'Camera & Photo',
        value: 'aDIxWADtJyoGmzapjS6V',
    },
    {
        label: 'Music & Accessories',
        value: 'brgyPsndlu91GLls1oTv',
    },
    {
        label: "Toys & Games",
        value: 'c4vklibshJYGsTeiGAv9',
    },
    {
        label: 'Electronics & Spare parts',
        value: 'cPUn5O6EBTF5WNMaZlT1',
    },
    {
        label: 'Computers',
        value: 'j8sZfmBVnLgOEQVVjDBa',
    },
    {
        label: 'Crafts & Art',
        value: 'mm6IGQPbFlavNRp66gLY',
    },
    {
        label: 'Video Games & Console',
        value: 'msjsxpHY9ZALocPZnxLl',
    },
    {
        label: 'Cell Phones & Accessories',
        value: 'oLVFCQyBD3E8nhCqADc4',
    },
    {
        label: 'Bicycles',
        value: 'sSSPwEoHQVSFanSjkXMN',
    },
    {
        label: 'Tools',
        value: 'uUSqaEk3prRiNKg2UIPw',
    },
    {
        label: 'Everything Else',
        value: 'vZvP8HJpq5GMFnK2mtTW',
    },
];